// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_0d624b9a27--layout--EBeGK"};